<div class="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
  <div class="text-center">
    <h1 class="text-6xl font-bold text-gray-900 dark:text-white mb-4">404</h1>
    <h2 class="text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-4">{{ 'common.pageNotFound' | translate }}</h2>
    <p class="text-gray-600 dark:text-gray-400 mb-8">{{ 'common.pageNotFoundDescription' | translate }}</p>
    <p-button label="{{ 'common.goHome' | translate }}" icon="pi pi-home" routerLink="/"
              styleClass="p-button-primary"></p-button>
  </div>
</div>